import { ParticipantQueueAPI } from '@sscale/celebritysdk';

const participantQueueAPI = new ParticipantQueueAPI();

export default participantQueueAPI;
